const swipePower = (offset, velocity) => {
	return Math.abs(offset) * velocity;
};

export default swipePower;
